import { useContext, ChangeEvent, useState, useEffect } from 'react'
import { Box, Hidden } from '@hermes/web-components'
import { useRouter } from 'next/router'
import { HomePageContext } from '../../../providers/HomePage'
import { useTimeout } from '../../../hooks/useTimeout'
import WebView from './WebView'
import MobileView from './MobileView'

const SearchBar = () => {
  const {
    buildUrl,
    changeSearchType,
    changeSearch,
    changeLocationSearch,
    loadCurrentLocationByLatLon,
    resetValidation,
    changeButtonLoadingState
  } = useContext(HomePageContext)
  const router = useRouter()

  const [isSearchFieldFocused, setIsSearchFieldFocused] = useState(false)
  const [isLocationFieldFocused, setIsLocationFieldFocused] = useState(false)
  const [openSearchTypeDropdown, setOpenSearchTypeDropdown] = useState(false)

  const timeout = useTimeout()

  const onChangeSearch = (ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => changeSearch(ev.target.value)

  const onChangeLocationSearch = (ev: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    timeout(() => changeLocationSearch(ev.target.value))

  const onSearchFieldFocus = () =>
    timeout(() => {
      resetValidation()
      setIsSearchFieldFocused(true)
    })

  const onSearchFieldBlur = () =>
    timeout(() => {
      setIsSearchFieldFocused(false)
    })

  const getYourLocation = () => {
    timeout(() => {
      navigator.geolocation.getCurrentPosition((position) => {
        loadCurrentLocationByLatLon(position.coords.latitude.toString(), position.coords.longitude.toString())
      })
    })
  }

  useEffect(() => {
    if (isLocationFieldFocused) {
      resetValidation()
    }
  }, [isLocationFieldFocused, resetValidation])

  useEffect(() => {
    if (openSearchTypeDropdown || isSearchFieldFocused || isLocationFieldFocused) {
      window.scrollTo({ top: 220, behavior: 'smooth' })
    }
  }, [openSearchTypeDropdown, isSearchFieldFocused, isLocationFieldFocused])

  const handleSearch = () => {
    const url = buildUrl()

    changeButtonLoadingState(true)

    if (url) {
      router.push(url)
    } else {
      changeButtonLoadingState(false)
    }
  }

  return (
    <Box sx={{ zIndex: 99, width: '100%' }}>
      <Hidden lgDown implementation="css">
        <Box width="100%" position="relative">
          <WebView
            isClientSide={false}
            getYourLocation={getYourLocation}
            openSearchTypeDropdown={openSearchTypeDropdown}
            setOpenSearchTypeDropdown={setOpenSearchTypeDropdown}
            isSearchFieldFocused={isSearchFieldFocused}
            isLocationFieldFocused={isLocationFieldFocused}
            onChangeLocationSearch={onChangeLocationSearch}
            onChangeSearch={onChangeSearch}
            onChangeSearchType={changeSearchType}
            onSearchFieldBlur={onSearchFieldBlur}
            onSearchFieldFocus={onSearchFieldFocus}
            handleSearch={handleSearch}
            setIsSearchFieldFocused={setIsSearchFieldFocused}
            setIsLocationFieldFocused={setIsLocationFieldFocused}
          />
        </Box>
      </Hidden>
      <Hidden lgUp implementation="css">
        <MobileView
          isClientSide={false}
          getYourLocation={getYourLocation}
          openSearchTypeDropdown={openSearchTypeDropdown}
          setOpenSearchTypeDropdown={setOpenSearchTypeDropdown}
          isSearchFieldFocused={isSearchFieldFocused}
          onChangeLocationSearch={onChangeLocationSearch}
          onChangeSearch={onChangeSearch}
          onChangeSearchType={changeSearchType}
          onSearchFieldBlur={onSearchFieldBlur}
          onSearchFieldFocus={onSearchFieldFocus}
          setIsSearchFieldFocused={setIsSearchFieldFocused}
          isLocationFieldFocused={isLocationFieldFocused}
          handleSearch={handleSearch}
          setIsLocationFieldFocused={setIsLocationFieldFocused}
        />
      </Hidden>
    </Box>
  )
}

export default SearchBar
